export interface UserModel {
  AccountStatusID: number,
  AccountStatusIDText: string,
  AutoDelete: number,
  AutoSuspend: number,
  Deleted: boolean,
  EMailAddress: string, //Norman.Farrar@lanyon.com,
  FirstName: string, //Norman,
  FullName: string, //Norman Farrar,
  LastLogin: Date, //\/Date(1500314420160-0500)\/,
  LastName: string, //Farrar,
  LockedOut: boolean,
  MiddleName: string, // null,
  Passsword: number[],
  PasswordChangeRequired: number,
  RoleString: string, //Corporate Admin,
  SecurityAnswer: string,
  SecurityQuestion: string,
  SecurityRole: number,
  Suspended: boolean,
  UserID: string, //8e5321ee-f256-4799-9842-33cbf4a49e81,
  UserName: string,
  UserPasswordResetViaEmail: boolean,
  UserRequiredToChangePAsswordOnFirstLogin: boolean,
  PotralUserid :number
}
export		enum UserActions
		{
			Delete,
			UnDelete,
			Lock,
			UnLock,
			Suspend,
			UnSuspend
    };
    
export function initUserModel(): UserModel {
return{
  AccountStatusID: 0,
  AccountStatusIDText: '',
  AutoDelete: 0,
  AutoSuspend: 0,
  Deleted: false,
  EMailAddress: '', //Norman.Farrar@lanyon.com,
  FirstName: '', //Norman,
  FullName: '', //Norman Farrar,
  LastLogin: null, //\/Date(1500314420160-0500)\/,
  LastName: '', //Farrar,
  LockedOut: false,
  MiddleName: '', // null,
  Passsword: [],
  PasswordChangeRequired: 0,
  RoleString: 'Registered User', //Corporate Admin,
  SecurityAnswer: '',
  SecurityQuestion: '',
  SecurityRole: 3,
  Suspended: false,
  UserID: '', //8e5321ee-f256-4799-9842-33cbf4a49e81,
  UserName: '',
  UserPasswordResetViaEmail: false,
  UserRequiredToChangePAsswordOnFirstLogin: false,
  PotralUserid : null
};
}
